export interface ISerologyFinalXmBloodDraw {
    serologyTrackingId: number,
    donorId: number,
    donorAlias: string,
    donorCenterId: number,
    donorCenterAlias: string,
    swapNumber: string,
    bloodDrawDate: string,
    donorSurgeryDate: string,
    recipientSurgeryDate: string,
    serologyUploadDate: string,
    recipientId: number,
    finalXmId: number,
    finalXmUploadDate: string,
    deltaDays: number
}
